import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { FacilityCompat, FacilityHelper } from 'src/app/contacts/facility-details/facility-helper';
import { AssetsApi } from 'src/app/hickory-api';
import { ApiError } from 'src/app/shared/model/utility';


export interface FacilityDetailsData  {
  assetId?: string;
  facility?: FacilityCompat,
  title?: string;
}

@Component({
  selector: 'app-facility-details-dialog',
  templateUrl: './facility-details-dialog.component.html',
  styleUrls: ['./facility-details-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false
})
export class FacilityDetailsDialogComponent implements OnInit {
  readonly locale = inject<L10nLocale>(L10N_LOCALE);
  readonly data = inject<FacilityDetailsData>(MAT_DIALOG_DATA);
  private readonly assetsApi = inject(AssetsApi);

  facility: FacilityCompat;
  addressQuery: string;
  addressParts: Array<string>;
  dialogTitle: string;
  loadError: string = null;
  hideRetry: boolean = false;

  ngOnInit(): void {
    this.facility = this.data.facility;
    this.addressQuery = FacilityHelper.getMapsAddressQuery(this.facility);
    this.addressParts = FacilityHelper.getAddressParts(this.facility);
    this.dialogTitle = this.data.title ?? 'Facility Details';
    this.loadAsset();
  }

  loadAsset() {
    if (!!this.facility || !this.data?.assetId) return;
    this.loadError = null;
    this.hideRetry = false;
    this.assetsApi.findAssets(1, 1, [this.data.assetId]).subscribe({
      next: (res) => {
        if (res?.items?.length) {
          this.facility = FacilityHelper.fromAsset(res.items[0]);
          this.addressQuery = FacilityHelper.getMapsAddressQuery(this.facility);
          this.addressParts = FacilityHelper.getAddressParts(this.facility);
        } else {
          this.onDetailsNotFound();
        }
      },
      error: (err: ApiError) => {
        this.loadError = 'An error occurred retrieving facility details';
        if (err.status === 404) {
          this.onDetailsNotFound();
        } 
      }
    });
  }

  private onDetailsNotFound() {
    this.loadError = 'No details found for this facility';
    this.hideRetry = true;
  }
}
